// Import AppConstants after defining UACConstants
import AppConstants from "./index";

const UACConstants = {
  // Menu Level
  STANDARD_DELIVERY: 'STANDARD_DELIVERY',
  EXPRESS_DELIVERY: 'EXPRESS_DELIVERY',
  DRIVER_MANAGEMENT: 'DRIVER_MANAGEMENT',
  STORES: 'STORES',
  OTHER_DELIVERIES: 'OTHER_DELIVERIES',
  ALL_ORDERS: 'ALL_ORDERS',
  ADMINISTRATION: 'ADMINISTRATION',
  USERS: 'USERS',
  DELVE: 'DELVE',
  
  // Standard Delivery SubMenu
  SD_PLANNING: 'SD_PLANNING',
  SD_DASHBOARD: 'SD_DASHBOARD',
  SD_TRACKING: 'SD_TRACKING',
  SD_COD: 'SD_COD',
  SD_EXPRESS_LEB: 'SD_EXPRESS_LEB',
  
  // Express Delivery SubMenu
  ED_HOME: 'ED_HOME',
  ED_DRIVERS: 'ED_DRIVERS',
  ED_COD: 'ED_COD',

   // Driver Management SubMenu
  DM_DRIVERS: 'DM_DRIVERS',
  DM_TIPS: 'DM_TIPS',
  DM_LOCATIONS: 'DM_LOCATIONS',
  DM_ONBOARDING: 'DM_ONBOARDING',

  // Other Deliveries SubMenu
  OD_CNC: 'OD_CNC',
  VALLEY_TROLLEY: 'VALLEY_TROLLEY',
  HOME_DELIVERY: 'HOME_DELIVERY',
  
  // All Orders SubMenu
  AO_HOME: 'AO_HOME',
  AO_RETURNS: 'AO_RETURNS',
  
  // Administration SubMenu
  STG_LOCATIONS: 'STG_LOCATIONS',
  COMMUNICATIONS: 'COMMUNICATIONS',
  
  // Delve SubMenu
  DELVE_DASHBOARD: 'DELVE_DASHBOARD',
  DELVE_ORDER_LIST: 'DELVE_ORDER_LIST',
  
  // Standard Delivery Planning Tabs
  SD_CONSIGNMENTS: 'SD_CONSIGNMENTS',
  SD_ROUTES: 'SD_ROUTES',
  SD_ALL_ROUTES: 'SD_ALL_ROUTES',
  
  // Standard Delivery Dashboard Tabs
  SD_HOME_DASHBOARD: 'SD_HOME_DASHBOARD',
  SD_HW_DASHBOARD: 'SD_HW_DASHBOARD',
  
  
  
  // Standard Delivery COD Tabs
  SD_COD_DASHBOARD: 'SD_COD_DASHBOARD',
  
  // Valet Trolley Tabs
  VT_ORDERS: 'VT_ORDERS',
  VT_ROUTES: 'VT_ROUTES',

  // Driver Tips Tabs
  DM_TIPS_EXPRESS: 'DM_TIPS_EXPRESS',
  DM_TIPS_STANDARD: 'DM_TIPS_STANDARD',
  DM_TIPS_ALL: 'DM_TIPS_ALL',
  
  // Home Delivery Tabs
  HD_ORDERS: 'HD_ORDERS',
  HD_ROUTES: 'HD_ROUTES',
  
  // Delve Dashboard Tabs
  DD_DELIVERIES: 'DD_DELIVERIES',
  DD_RETURNS: 'DD_RETURNS',
  
  // Delve Order List Tabs
  DOL_DELIVERIES: 'DOL_DELIVERIES',
  DOL_RETURNS: 'DOL_RETURNS',

  RETURNS: 'RETURNS',
  DOWNLOAD_APP: 'APP_DOWNLOAD',
  REPORT: 'REPORT',
  DRIVERS: 'ED_DRIVERS',
  OPS_DASHBOARD: 'OPS_DASHBOARD',

  // Store Sections
  STORES_CLUB_LIMIT_SECTION: 'STORES_CLUB_LIMIT_SECTION',

  // Express Delivery Buttons
  ED_HOME_COURIER_SWITCH_BTN: 'ED_HOME_COURIER_SWITCH_BTN',

  //Users Active Session
  USERS_END_ACTIVE_SESSION: 'USERS_END_ACTIVE_SESSION',
};

export default UACConstants;

export const UAC_ROUTE_MAP: { [key: string]: string } = {
  // MENU-level keys (map to their primary submenu route)
  [UACConstants.STANDARD_DELIVERY]: AppConstants.ROUTES.PLANNING,
  [UACConstants.EXPRESS_DELIVERY]: AppConstants.ROUTES.CARREFOUR_NOW,
  [UACConstants.DRIVER_MANAGEMENT]: AppConstants.ROUTES.DRIVERS,
  [UACConstants.OTHER_DELIVERIES]: AppConstants.ROUTES.CLICKNCOLLECT,
  [UACConstants.ADMINISTRATION]: AppConstants.ROUTES.STAGING_AREA,
  [UACConstants.DELVE]: AppConstants.ROUTES.DELVE_DASHBOARD,
  [UACConstants.ALL_ORDERS]: AppConstants.ROUTES.ALL_ORDERS,

  // Standard Delivery
  [UACConstants.SD_PLANNING]: AppConstants.ROUTES.PLANNING,
  [UACConstants.SD_DASHBOARD]: AppConstants.ROUTES.PERFORMANCE,
  [UACConstants.SD_TRACKING]: AppConstants.ROUTES.TRACKING,
  [UACConstants.SD_COD]: AppConstants.ROUTES.STD_COD_PORTAL,
  [UACConstants.SD_EXPRESS_LEB]: AppConstants.ROUTES.EXPRESS,
  
  // Express Delivery
  [UACConstants.ED_HOME]: AppConstants.ROUTES.CARREFOUR_NOW,
  [UACConstants.ED_DRIVERS]: AppConstants.ROUTES.DRIVERS,
  [UACConstants.ED_COD]: AppConstants.ROUTES.COD_PORTAL,

  // Driver Management
  // [UACConstants.DRIVER_MANAGEMENT]: AppConstants.ROUTES.DRIVERS,
  [UACConstants.DM_DRIVERS]: AppConstants.ROUTES.DRIVERS,
  [UACConstants.DM_TIPS]: AppConstants.ROUTES.DRIVER_TIPS,
  [UACConstants.DM_LOCATIONS]: AppConstants.ROUTES.DRIVER_LOCATIONS,
  [UACConstants.DM_ONBOARDING]: AppConstants.ROUTES.DRIVER_ONBOARDING,
  
  // Stores
  [UACConstants.STORES]: AppConstants.ROUTES.STORE_MANAGEMENT,
  
  // Other Deliveries
  [UACConstants.OD_CNC]: AppConstants.ROUTES.CLICKNCOLLECT,
  [UACConstants.VALLEY_TROLLEY]: AppConstants.ROUTES.VALETTROLLEY,
  [UACConstants.HOME_DELIVERY]: AppConstants.ROUTES.CARREFOUR_HOME_DLVRY,
  
  // All Orders
  [UACConstants.AO_HOME]: AppConstants.ROUTES.ALL_ORDERS,
  [UACConstants.AO_RETURNS]: AppConstants.ROUTES.RETURNS,
  
  // Administration
  [UACConstants.STG_LOCATIONS]: AppConstants.ROUTES.STAGING_AREA,
  [UACConstants.COMMUNICATIONS]: AppConstants.ROUTES.CUSTOMER_COMMUNICATION,
  
  // Users
  [UACConstants.USERS]: AppConstants.ROUTES.USERS,
  
  // Delve
  [UACConstants.DELVE_DASHBOARD]: AppConstants.ROUTES.DELVE_DASHBOARD,
  [UACConstants.DELVE_ORDER_LIST]: AppConstants.ROUTES.DELVE_ORDER_LIST,
  
  // Reports
  [UACConstants.REPORT]: AppConstants.ROUTES.REPORTS,
  
  // App Download
  [UACConstants.DOWNLOAD_APP]: AppConstants.ROUTES.APP_DOWNLOAD,

  // Ops Dashboard
  [UACConstants.OPS_DASHBOARD]: AppConstants.ROUTES.OPS_DASHBOARD,
};

export const UAC_ICON_MAP: { [key: string]: any } = {
  [UACConstants.STANDARD_DELIVERY]: "stdDeliveryIcon",
  [UACConstants.EXPRESS_DELIVERY]: "expressDeliveryIcon",
  [UACConstants.STORES]: "offlineDeliveryIcon",
  [UACConstants.OTHER_DELIVERIES]: "DotsThreeOutlineIcon",
  [UACConstants.ALL_ORDERS]: "allOrdersIcon",
  [UACConstants.ADMINISTRATION]: "hubsIcon",
  [UACConstants.USERS]: "usersNavLogoIcon",
  [UACConstants.DELVE]: "delveGroupIcon",
  [UACConstants.DRIVER_MANAGEMENT]: "usersDriverLogoIcon",
  [UACConstants.REPORT]: "reportIcon",
  [UACConstants.DOWNLOAD_APP]: "dwnloadAppIcon",
  [UACConstants.OPS_DASHBOARD]: "opsDashboardIcon",
};

export interface UACItem {
  name: string;
  key: string;
  permissions: string[];
  type: "MENU" | "SUBMENU" | "TABS" | "SECTION" | "BUTTON";
  parentKey?: string;
}

export interface UACResponse {
  defaultMenu: string;
  uac: UACItem[];
}
